<template>
    <div>
        <div class="title-nav">
            <div class="weui-cells__title">
                <p style="font-size: 20px; color: #fff">{{statistics.worksite.shortName}}{{statistics.worksite.schoolCampus}} 业务统计</p>
                <p style="color: #fff">（{{statistics.time}}）</p>
            </div>
        </div>
        <div class="weui-cells">
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>入库件数</p>
                </div>
                <div class="weui-cell__ft">{{statistics.toSendCount}} 件</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>完成派件</p>
                </div>
                <div class="weui-cell__ft">{{statistics.sendedCount}} 件</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>派件滞留</p>
                </div>
                <div class="weui-cell__ft">{{statistics.toSendDelayCount}} 件</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>退派数量</p>
                </div>
                <div class="weui-cell__ft">{{statistics.returnCount}} 件</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>寄件件数</p>
                </div>
                <div class="weui-cell__ft">{{statistics.takeinCount}} 件</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>寄件收入</p>
                </div>
                <div class="weui-cell__ft">{{statistics.takeinIncome / 100}} 元</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>送件上门</p>
                </div>
                <div class="weui-cell__ft">{{statistics.doorServiceTosendCount}} 件</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>上门收件</p>
                </div>
                <div class="weui-cell__ft">{{statistics.doorServiceTakeinCount}} 件</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>跑腿业务</p>
                </div>
                <div class="weui-cell__ft">{{statistics.paotuiBizCount}} 单</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>跑腿收入</p>
                </div>
                <div class="weui-cell__ft">{{statistics.paotuiIncome / 100}} 元</div>
            </div>
            <div class="weui-cell" v-if="isZongbuAdmin">
                <div class="weui-cell__bd">
                    <p>新增用户</p>
                </div>
                <div class="weui-cell__ft">{{statistics.wxuserSubscribeCount}} 人</div>
            </div>
            <div class="weui-cell" v-if="isZongbuAdmin">
                <div class="weui-cell__bd">
                    <p>实名认证</p>
                </div>
                <div class="weui-cell__ft">{{statistics.authVerifyCount}} 人</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>新增跑腿</p>
                </div>
                <div class="weui-cell__ft">{{statistics.paotuiVerifyCount}} 人</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>短信发送</p>
                </div>
                <div class="weui-cell__ft">{{statistics.smsCount}} 条</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>短信费用</p>
                </div>
                <div class="weui-cell__ft">{{statistics.smsCost / 100}} 元</div>
            </div>
        </div>
        <div class="weui-footer">
            <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
            </p>
            <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import weui from "weui.js";
import moment from "moment";

export default {
  data() {
    return {
      isZongbuAdmin: false,
      isWangdianAdmin: false,
      day: "",
      year: moment().format("YYYY"),
      statistics: {
        worksite: {}
      }
    };
  },
  created() {
    let zongbuRoleId = "5affadba9c646c0d743ee783";
    let wangdianguanliyuanRoleId = "5b063605841edc3b688634c5";
    let encodeToken = this.$route.params.token;
    let token = decodeURIComponent(encodeToken);
    let _id = this.$route.params.id;
    axios.defaults.headers["Authorization"] = "Bearer " + token;

    let loading = weui.loading("数据加载中", {
      className: "custom-classname"
    });

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        if (response.data.success) {
          let openid = response.data.data.openid;
          let unionid = response.data.data.unionid;
          // 根据openid 获取用户信息
          axios
            .get("/auth/employee/getByUnionid/" + unionid)
            .then(res => {
              if (res.data.success) {
                let roles = res.data.user.roles;
                for (let i = 0; i < roles.length; i++) {
                  if (zongbuRoleId == roles[i]) {
                    this.isZongbuAdmin = true;
                  } else if (wangdianguanliyuanRoleId == roles[i]) {
                    this.isWangdianAdmin = true;
                  }
                }

                if (this.isZongbuAdmin || this.isWangdianAdmin) {
                  axios
                    .get("/api/statistics/getById/" + _id)
                    .then(res => {
                      if (res.data.success) {
                        loading.hide(function() {});
                        this.statistics = res.data.data;
                      } else {
                        weui.toast(res.data.message, 2000);
                      }
                    })
                    .catch(err => {
                      weui.toast(err, 2000);
                    });
                }else {
                    loading.hide(function() {});
                }
              } else {
                loading.hide(function() {});
                weui.alert("获取用户信息失败");
              }
            })
            .catch(err => {
              loading.hide(function() {});
              weui.alert("获取用户信息失败");
            });
        } else {
          loading.hide(function() {});
          weui.alert("获取用户信息失败");
        }
      })
      .catch(error => {
        loading.hide(function() {});
        weui.alert("获取用户信息失败");
      });
  }
};
</script>

<style scoped>
.title-nav {
  position: absolute;
  height: 90px;
  width: 100%;
  background-color: #1aad19;
  top: 0px;
  color: #fff;
}
.weui-cells {
  margin-top: 90px;
}
.weui-cells__title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: gray;
  margin-bottom: 0px;
}
.weui-cell__ft {
  color: #1aad19;
}
.weui-footer {
  margin-top: 30px;
  margin-bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/infos/StatisticsDetail.vue